import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import ReactSelect from "../../../../app/modules/UI/ReactSelect";

const initialValues = {
    cardId: '',
 
}

export default function Create(props) {
  const token = useSelector((state) => state.auth.token)
  const { show, onHide,cardId,id ,onLogRows} = props
  const [isError, setIsError] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const [cardsOption, setCardsOption] = React.useState(null);

  const CreateSchema = Yup.object().shape({
   
    cardId: Yup.string().required('Kart tələb olunur.'),
  
  })

  
  const onPostGroup = (values, resetForm, setSubmitting) => {
    setIsLoading(true);

    const card = {
     cardId: values.cardId,
    }
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}card/user/${id}?${card.cardId ? `&cardId=${card.cardId}`:""}`,
      data: card,
      headers: {
        Authorization: `bearer ${token}`,
      },
    })
      .then((res) => {
        onLogRows()
        setSubmitting(false)
        resetForm()
        onHide(false)
        setIsLoading(false);

      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsLoading(false);
      });
  }

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostGroup(values, resetForm, setSubmitting)
    },
  })

  const resetForm = () => {
    onHide()
    formik.resetForm()
  }

  useEffect(() => {
    setIsError('')
  }, [show])


  
//  useEffect(() => {
//   // console.log(permissions);
//   console.log(cardsOption);
// }, [cardsOption]);


function handleChangeCards(value) {
  setCardsOption(value);
  formik.setFieldValue("cardId", value.value);
}
  return (
    <Modal
      size="md"
      aria-labelledby="create"
      centered
      className="modal pr-0"
      show={show}
      onHide={resetForm}
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="create">Əlavə et</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
             
            <div className="col-12 col-md-12 col-lg-12">
            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
            <input
            type="text"
            name="cardId"
            hidden
            {...formik.getFieldProps("cardId")}
          />

          <ReactSelect
            suggestions={cardId}
            handleChangeSingle={handleChangeCards}
            single={cardsOption}
            label="Kart seçin"
            placeholder="Kart seçin"
            inputId="cardId"
          />
            </div>
            {formik.touched.cardId && formik.errors.cardId ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.cardId}</div>
              </div>
            ) : null}
         
          </div>
        
              {isError && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block MuiFormLabel-root Mui-error">
                    {isError}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false)
              formik.resetForm()
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Əlavə et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
